<template>
    <div class="login-page" :style="bgStyle">
        <div class="login-box">
            <div class="logo">
                <el-image :src="logo"></el-image>
            </div>
            <div class="from">
                <el-form :model="formData" :rules="rules" ref="formData" hide-required-asterisk @submit.native.prevent="submitForm">
                    <el-form-item prop="telephone">
                        <el-input v-model="formData.telephone" placeholder="员工手机号"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="formData.password" placeholder="登录密码" type="password"></el-input>
                    </el-form-item>
                    <el-form-item prop="verifyCode">
                        <el-row :gutter="8">
                            <el-col :span="15">
                                <el-input v-model="formData.verifyCode" placeholder="短信验证码"></el-input>
                            </el-col>
                            <el-col :span="9">
                                <el-button
                                    native-type="button"
                                    type="primary"
                                    @click="getCode()"
                                    :disabled="codeBtn.disabled"
                                    :loading="codeBtn.loading"
                                >{{codeBtn.btnText}}</el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item class="btn-box">
                        <el-button type="primary" @click="submitForm()" :loading="loginLoading" native-type="submit">登 录</el-button>
                    </el-form-item>
                    <!-- 飞书SSO扫码登录入口 -->
                    <div class="sso-box">
                        <el-button type="text" @click="toFeishuSSO">飞书SSO扫码登录</el-button>
                    </div>
                </el-form>
            </div>
            <div class="copyright">©{{new Date().getFullYear()}} Showstart.com. All Rights Reserved.<br/><a href="https://beian.miit.gov.cn/" class="color-info" target="_blank">{{ $utils.copyright.icp }}</a></div>
        </div>
    </div>
</template>

<script>
import logo from "@/assets/img/login/logo.png";
import {getMenuList,verificationSwitch} from '@/assets/js/commonApi';
const staticUrl = "https://s3.showstart.com";
var md5 = require('js-md5');
const bgImgs = [
    staticUrl +
        "/img/2020/20200120/956f8782930f4ebca8c3114c2c6ed055_2000_1058_254566.0x0.jpg",
    staticUrl +
        "/img/2020/20200120/93f9aeb6f7d84eb59d463bfe5de9845e_2000_1058_302786.0x0.jpg",
    staticUrl +
        "/img/2020/20200120/4ff8e9fc9628493cbd9922ad1b72cbbc_2000_1058_275348.0x0.jpg",
];
export default {
    name: "loginPage",
    data() {
        return {
            logo: logo,
            formData: {
                telephone: "",
                verifyCode: "",
                formToken: this.$utils.uuid(),
                password: "",
            },
            rules: {
                telephone: [
                    { required: true, message: "请输入员工手机号" },
                    { validator: this.$utils.validatePhone },
                ],
                verifyCode: [
                    { required: true, message: "请填写正确的短信验证码" },
                ],
                password: [
                    { required: true, message: "请填写登录密码" },
                ]
            },
            codeBtn: {
                btnText: "获取验证码",
                disabled: false,
                loading: false
            },
            bgImg: bgImgs[Math.floor(Math.random() * 3)],
            bgStyle: "",
            loginLoading: false,
            captcha: null,
        };
    },
    created() {
        const that = this;
        this.bgStyle = "backgroundImage:url('" + this.bgImg + "')";
        this.$utils.loadScript(
            {
                id:'tcaptcha',
                url:'https://turing.captcha.qcloud.com/TCaptcha.js' // old https://ssl.captcha.qq.com/TCaptcha.js
            },
            () =>{
                // eslint-disable-next-line no-undef
                this.captcha = new TencentCaptcha(
                    "2032912416", 
                    function(res){
                        if(res.ret === 0){
                            that.getCodeEvent( res );
                        }
                    }
                );
            }
        )
    },
    methods: {
        //飞书SSO扫码登录（新窗口打开）
        toFeishuSSO() {
            window.open('https://sso.showstart.com', '_blank');
        },
        //获取短信验证码（validateField 回调按字段各触发一次，故分两步校验避免重复请求）
        getCode() {
            this.$refs["formData"].validateField(["telephone"],(err) => {
                if(!err){
                    this.$refs["formData"].validateField(["password"],async (err2) => {
                        if(!err2){
                            const res = await  verificationSwitch(); //获取验证码设置
                            const { state, msg, result } = res.data;
                            if (state != 1) {
                                this.$message.error(msg || "获取验证码设置失败");
                            } else {
                                if( result.adminLogin ){
                                    this.captcha.show();
                                }else{
                                    this.getCodeEvent();
                                }
                            }
                        }
                    });
                }
            });
        },
        getCodeEvent(_res){
            this.codeBtn.loading = true;
            this.$request({
                url: "/login/verifyCode",
                method: "POST",
                data: {
                    formToken: this.formData.formToken,
                    telephone: this.formData.telephone,
                    password: md5(this.formData.password).toLowerCase(), // 密码md5密文
                    randStr:_res && encodeURIComponent(_res.randstr) || '',
                    ticket: _res && encodeURIComponent(_res.ticket) || '',
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state != 1) {
                        this.$message.error(msg || "请求失败");
                    } else {
                        // this.formData.verifyCode = res.data.result;
                        this.dtime(60)
                    }
                })
                .catch(() => {
                    this.$message.error('请求错误');
                }).finally( () => {
                    this.codeBtn.loading = false;
                });
        },
        dtime( time ){
            var that = this , _time = time;
            if( _time <= 0 ){
                this.codeBtn.btnText = '获取验证码';
                this.codeBtn.disabled = false;
            }else{
                this.codeBtn.btnText =  _time+'秒后重试' ;
                _time --;
                this.codeBtn.disabled = true;
                let t1 = setTimeout(function(){ that.dtime( _time );clearTimeout(t1); } , 1000);
            }
        },
        //提交表单
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.loginLoading = true;
                    this.$request({
                        url: "/login",
                        method: "POST",
                        data: {
                            ...this.formData,
                            systime:new Date().getTime(),
                            password: md5(this.formData.password).toLowerCase()
                        }
                    }).then( res => {
                        const { state, msg, result } = res.data;
                        if (state != 1) {
                            this.$message.error(msg || "请求失败");
                        } else {
                            const redirect = self.$route.query.redirect || '/';

                            self.$store.commit( 'setCUSUT', result.idToken || "" );
                            self.$store.commit('setUserInfo',result);
                            self.$store.commit( 'setPriviList', result.privileges || null );

                            //getUserInfo();//获取登录用户信息
                            getMenuList();//获取登录用户拥有的菜单权限
                            self.$router.push(redirect);
                        }
                    }).catch(() => {
                        this.$message.error('请求错误');
                    }).finally( () => {
                        this.loginLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>